import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import * as Yup from 'yup';

import Master from '../../../Layouts/Master';
import { useApi } from '../../../Hooks/Api';
import { useToast } from '../../../Hooks/Toast';
import { Form, Text } from '../../../Components/Form';
import { serverErrorHandler } from '../../../Utils/Helpers';
import TitleBar from '../../../Components/TitleBar/TitleBar';

const validationSchema = Yup.object({
  side: Yup.string()
    .typeError('سمت الزامی است')
    .required('سمت الزامی است')
    .max(190, 'سمت نمی تواند بیشتر از 190 کاراکتر باشد'),
});

const Create = () => {
  const [formSubmitLoading, setFormSubmitLoaing] = useState(false);
  const [serverErrors, setServerErrors] = useState({});
  const { post } = useApi();
  const { error, success } = useToast();
  const navigate = useNavigate();

  const submitForm = async (values, setSubmitingForm) => {
    setFormSubmitLoaing(true);
    await post(
      '/agent',
      values,
      (res) => {
        success(`عوامل اجرایی "${values?.side}" باموفقیت ایجاد شد.`);
        setFormSubmitLoaing(false);
        navigate('/agent');
      },
      (err) => {
        if (err?.status === 422) {
          serverErrorHandler(err?.data?.errors, setServerErrors, serverErrors);
          error('لطفا خطاهای فرم را رفع کنید.');
        } else {
          error(`عوامل اجرایی "${values?.side}" به علت خطا ایجاد نشد.`);
        }
        setFormSubmitLoaing(false);
      },
    );
  };
  return (
    <Master>
      <TitleBar
        title='ایجاد عوامل اجرایی'
        showBackBtn={true}
        showCreateBtn={false}
        showFilterBtn={false}
        backPath='/agent'
      />
      <Form
        initialValues={{
          side: '',
        }}
        loading={formSubmitLoading}
        onSubmit={submitForm}
        validationSchema={validationSchema}
      >
        <div className='row'>
          <div className='col-12 col-md-12'>
            <div className='row'>
              <div className='col-12'>
                <Text title='سمت' name='side' serverError={serverErrors.side} />
              </div>
            </div>
          </div>
        </div>
      </Form>
    </Master>
  );
};

export default Create;
